module.exports = __webpack_public_path__ + "bed-quilt1-slogan.483ed3fa.png";